export default "__VITE_ASSET__CI4vFAT7__"